export const API_BASE_URL =
  process.env.REACT_APP_MYDATA_API_BASE_URL || window.location.origin;
export const API_SA_BASE_URL =
  process.env.REACT_APP_SA_BASE_URL || "https://account.samsung.com";
export const API_CHINA_SA_BASE_URL =
  process.env.REACT_APP_CHINA_SA_BASE_URL || "https://account.samsung.cn";
export const MYDATA_HISTORY = `${API_BASE_URL}/my-data/history`;
export const API_PUBLIC_AUTH_TOKEN = process.env.API_PUBLIC_AUTH_TOKEN;

export const API_SA_V3_BASE_URL =
  process.env.REACT_APP_SA_V3_BASE_URL || "https://v3.account.samsung.com";

export const API_ENDPOINTS = {
  /**
   * @deprecated
   * This endpoint will be removed once V3 has been released by Feb. 2025.
   * Use `LOGIN` endpoint instead.
   */
  LOGIN_V1: "/accounts/v1/SDAP/signInGate",

  LOGIN: "/iam/oauth2/authorize",
  LOGOUT: "/accounts/v1/SDAP/signOutGate",
  AUTH_SIGNIN_URL: "/user/v2/tokens/access",
  AUTH_SIGNOUT_URL: "/user/v2/tokens/expire",
  PROFILE: "/user/v2/profile",
  GEOIP: "/mydata/v1/geoip",
  SA_PROFILE: "/membership/contents/profile",
  SERVICES: "/mydata/v1/service",
  SUMMARY: "/mydata/v1/summary",
  DETAILS: "/mydata/v1/history/detail",
  SEND_FILE_PASSWORD: "/mydata/v1/sendcode",
  CANCEL_REQUEST: "/mydata/v1/cancel",
  HISTORY: "/mydata/v1/history",
  CONFIRM_PASS_URL: "/accounts/v1/SDAP/confirmPasswordGate",
  MYDATA_DOWNLOAD: "/mydata/v1/download",
  MYDATA_DELETE: "/mydata/v1/delete",
  MYDATA_UNSUBSCRIBE: "/mydata/v1/unsubscribe",
  SURVEY: "mydata/v1/survey",
  VERIFY_OTP: "/mydata/v1/guest-login/verify-otp",
  EMAIL_LOGIN_SEND_OTP: "/mydata/v1/guest-login",
  SYSTEM_PROPERTIES: "/mydata/v1/system-properties",
  ADSSO_LOGIN_GUARD: "/mydata/v1/sso-login",
  EMAIL_SUPPORTED_COUNTRIES: "/mydata/v1/supported-country",
};
